import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DriverDetailsComponent } from './driver-details.component';
import { ManageDriverComponent } from './manage-driver.component';
import { TableModule } from 'primeng';

const routes: Routes = [
  { path: '', component: ManageDriverComponent, data: { title: 'Manage Drivers' } },
  { path: ':id', component: DriverDetailsComponent, data: { title: 'Driver Details' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageDriverRoutingModule {}

@NgModule({
  imports: [
    ManageDriverRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [ManageDriverComponent, DriverDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageDriverModule {}
